import React from 'react';
import Moment from 'react-moment';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import useFetch from 'use-http';
import {
  Card,
  CardContent,
  CardHeader,
  CardFooter,
} from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Download, SlashIcon } from 'lucide-react';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import { Heading } from '@/components/ui/shared/heading';
import { Link } from 'react-router-dom/cjs/react-router-dom';

const ReferralDetails = () => {
  const history = useHistory();
  const { get: getFile } = useFetch('/UserAccount/DownloadAmisFile');
  const referral = history.location?.state?.data;

  const handleFileDownload = async () => {
    await getFile(
      `?fileType=${referral.file.type}&fileGuid=${referral.file.guid}&category=Referral`,
    ).then((res) => {
      const base64Data = res;
      const blob = base64toBlob(base64Data, 'application/pdf');
      const downloadLink = document.createElement('a');
      downloadLink.href = URL.createObjectURL(blob);
      downloadLink.download =
        referral.practitioner?.qualification +
        '-' +
        referral.practitioner?.name +
        ' ' +
        referral.practitioner?.surname +
        ' ' +
        moment(new Date(referral.occurrenceDateTime)).format('YYYY-MM-DD') +
        '.pdf';

      document.body.appendChild(downloadLink);
      setTimeout(() => {
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }, 120);
    });
  };

  const base64toBlob = (base64Data, contentType = '') => {
    const sliceSize = 1024;
    const byteCharacters = atob(base64Data);
    const bytesLength = byteCharacters.length;
    const slicesCount = Math.ceil(bytesLength / sliceSize);
    const byteArrays = new Array(slicesCount);

    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      const begin = sliceIndex * sliceSize;
      const end = Math.min(begin + sliceSize, bytesLength);

      const bytes = new Array(end - begin);
      for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  };

  return (
    <div className="space-y-5">
      <Breadcrumb className="px-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/userAccount/referrals">Siuntimai</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator>
            <SlashIcon />
          </BreadcrumbSeparator>
          <BreadcrumbItem>
            <BreadcrumbPage>
              {referral.practitioner?.name} {referral.practitioner?.surname}
            </BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      {/* Card 1: Textual Info */}
      <Card>
        <CardHeader>
          <Heading variant="userAccountDetailsTitle">
            Siuntimo informacija
          </Heading>
        </CardHeader>
        <CardContent className="space-y-2">
          <div>
            <span>Data: </span>
            <span>
              {(new Date(
                Date.parse(referral.occurrenceDateTime),
              ).getUTCHours() === 0 && (
                <Moment utc format="YYYY-MM-DD">
                  {referral.occurrenceDateTime}
                </Moment>
              )) || (
                <Moment utc format="YYYY-MM-DD HH:mm">
                  {referral.occurrenceDateTime}
                </Moment>
              )}
            </span>
          </div>

          <div>
            <span>Gydytojas: </span>
            <span>
              {referral.practitioner?.qualification} -{' '}
              {referral.practitioner?.name} {referral.practitioner?.surname}
            </span>
          </div>

          <div>
            <span>Diagnozė: </span>
            <span>{referral.reason}</span>
          </div>

          <div>
            <span>Kokiam specialistui siuntimas parašytas: </span>
            <span>{referral.specialty}</span>
          </div>

          <div>
            <span>Siuntimo tikslas: </span>
            <span>
              {referral.intent &&
                referral.intent
                  .split(/\r?\n|<br\/>/)
                  .map((text, idx) => <span key={idx}>{text}</span>)}
            </span>
          </div>

          <div>
            <span>Galioja iki: </span>
            <span>
              <Moment format="YYYY-MM-DD">{referral.validUntil}</Moment>
            </span>
          </div>
        </CardContent>
        <CardFooter />
      </Card>

      {/* Card 2: Dokumentai */}
      {referral.file?.guid && (
        <Card>
          <CardHeader>
            <Heading variant="userAccountDetailsTitle">Dokumentai</Heading>
          </CardHeader>
          <CardContent>
            <Button variant="light" onClick={handleFileDownload}>
              <Download />
              Atsisiųsti PDF
            </Button>
          </CardContent>
          <CardFooter />
        </Card>
      )}
    </div>
  );
};

export default ReferralDetails;
